@if ((isLoggingIn$ | async) === true) {
  <div>
    <pcp-login-loading></pcp-login-loading>
  </div>
}

@if (loginError$ | async; as loginError) {
  <div>
    {{ loginError }}
  </div>
}
